import { render, staticRenderFns } from "./availability.vue?vue&type=template&id=047b9f27&scoped=true&"
import script from "./availability.vue?vue&type=script&lang=js&"
export * from "./availability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047b9f27",
  null
  
)

export default component.exports